import ArchiveDocumentRepository from "../data/ArchiveDocumentRepository";
import { ArchiveDocument, ArchiveFile } from "../entities/ArchiveDocument";

export default class ArchiveDocumentInteractor {
  private archiveDocumentRepository: ArchiveDocumentRepository;

  constructor(archiveDocumentRepository: ArchiveDocumentRepository) {
    this.archiveDocumentRepository = archiveDocumentRepository;
  }

  async searchArchive(
    orgId: string,
    lastName: string,
    firstName: string,
    studentId: string
  ): Promise<ArchiveDocument[]> {
    return this.archiveDocumentRepository.searchArchive(
      orgId,
      lastName,
      firstName,
      studentId
    );
  }

  async listArchiveFiles(
    orgId: string,
    folderId: string
  ): Promise<ArchiveFile[]> {
    return this.archiveDocumentRepository.listArchiveFiles(orgId, folderId);
  }

  async getArchiveFile(
    orgId: string,
    folderId: string,
    fileName: string
  ): Promise<Blob> {
    return this.archiveDocumentRepository.getArchiveFile(
      orgId,
      folderId,
      fileName
    );
  }

  async getOrderData(
    orgId: string,
    folderId: string
  ): Promise<Record<string, any>> {
    return this.archiveDocumentRepository.getOrderData(orgId, folderId);
  }
}
